import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { HowToWatchPanel } from '../../../../../../styles';

export const OtherCountriesDescription = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body3};
    ${BaseStyle.Mixins.gaps.tiny};
    color: ${({ theme }) => theme.Text.secondary};
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const OtherCountriesDescriptionButtonWrapper = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    color: ${({ theme }) => theme.Text.secondary};
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0 4px 4px 4px;
    margin-top: -8px;
`;

export const OtherCountriesButton = styled(HowToWatchPanel)`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    justify-content: center;
    align-items: center;
    width: 100%;
    cursor: pointer;
    background: ${({ theme }) => theme.Surface.Opposite.primary};
    color: ${({ theme }) => theme.Text.OppositeSurface.primary};
    height: 44px;
`;
